import React from 'react';
import {
  diffChars,
  diffWords,
  diffSentences,
  diffJson,
} from 'diff';
import './Diff.css';

const fnMap = {
  'chars': diffChars,
  'words': diffWords,
  'sentences': diffSentences,
  'json': diffJson,
};

class Diff extends React.Component {

  static defaultProps = {
    inputA: '',
    inputB: '',
    type: 'chars',
  };

  render() {
    const diff = fnMap[this.props.type](this.props.inputA, this.props.inputB);
    const result = diff.map(function(part, index) {
      let className = 'non';
      if (part.added) className = 'ins';
      if (part.removed) className = 'rem';
      return <span key={index} className={className}>{part.value}</span>;
    });
    return (
        <pre className={"diff-result " + this.props.type}>
          {result}
        </pre>
    );
  }
}

export default Diff;



// WEBPACK FOOTER //
// ./src/component/element/Diff.js